<template>
  <div>
    <div class="section-right-content-box">
      <div class="box-shadow top-box">
        <div class="global-title">新老客分析
          <el-popover
            placement="right"
            width="480"
            trigger="hover"
          >
            <div>1、新老客：首次付款时间在查询的下单时间段内为新客，反之为老客。</div>
            <div>2、新会员：在查询的绑卡时间内绑卡的人数（如：按日则为当天绑卡的人数;按月统计则为当月的绑卡人数）</div>
            <div>3、新会员占比：新会员数/新客数</div>
            <i class="el-icon-question" slot="reference" style="color: #aaaaaa;"></i>
          </el-popover>
        </div>
      </div>
      <div class="newAndOld_analysis">
        <!-- 查询条件 -->
        <el-form ref="form" :model="form" label-width="110px">
          <el-form-item label="下单时间：" required>
            <div class="my_select_time time_box">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.orderTimeStart"
                type="datetime"
                :placeholder="'开始时间'"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div
                class="time_to_text"
              >
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.orderTimeEnd"
                type="datetime"
                :placeholder="'结束时间'"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="false"
              ></el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="clearOrderTime()"
              ></i>
              <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
            </div>
            <el-radio
              v-for="item in radioList"
              :key="item.value"
              v-model="orderRadio"
              :label="item.value"
              @change="orderRadioChange"
              >{{ item.label }}</el-radio
            >
          </el-form-item>
          <el-form-item label="绑卡时间：" required>
            <div class="my_select_time time_box">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.openCardTimeStart"
                type="datetime"
                :placeholder="'开始时间'"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div
                class="time_to_text"
              >
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.openCardTimeEnd"
                type="datetime"
                :placeholder="'结束时间'"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="false"
              ></el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="clearBindTime()"
              ></i>
              <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
            </div>
            <el-radio
              v-for="item in radioList"
              :key="item.value"
              v-model="bindRadio"
              :label="item.value"
              @change="bindRadioChange"
              >{{ item.label }}</el-radio
            >
          </el-form-item>
          <el-form-item label="日期统计维度：">
            <el-select style="width: 204px;" v-model="form.statisticsType" placeholder="请选择">
              <el-option
                v-for="item in dimensionList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button class="status_btn status_btn1" icon="el-icon-search" type="primary" @click="queryData">查询</el-button>
            <el-button class="status_btn status_btn2" @click="resetData">重置</el-button>
            <el-button class="exportData" @click="exportData">导出数据</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background: '#fafafa', fontWeight: 700 }"
          style="width: 100%; margin-top: 24px;"
          :default-sort = "{prop: 'date', order: 'descending'}"
          show-summary
          :summary-method="getSummaries"
          v-loading="loading"
        >
          <el-table-column prop="date" label="日期" align="center" sortable>
          </el-table-column>
          <el-table-column prop="orderNum" label="下单用户" align="center" sortable>
          </el-table-column>
          <el-table-column prop="oldOrderNum" label="老客下单人数" align="center" sortable>
          </el-table-column>
          <el-table-column prop="newOrderNum" label="新客下单人数" align="center" sortable>
          </el-table-column>
          <el-table-column prop="newMemberNum" label="新会员" align="center" sortable>
          </el-table-column>
          <el-table-column prop="memberRateVal" label="新会员占比（新会员/新客）" align="center" sortable>
            <template slot-scope="scope">
              {{ scope.row.newMemberRate }}
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="empty">
              <img src="@/assets/images/default/暂无任何数据.png" />
              <div>暂无任何数据</div>
            </div>
          </template>
        </el-table>
      </div>
    </div>

    <!-- 生成报表 -->
    <generate
      v-if="control"
      :control="control"
      @transData="(val) => (control = val)"
      @transData1="getphone"
    />
  </div>
</template>

<script>
import generate from "@/components/generate_report.vue";
import { exportDataOne, getTableData } from "@/api/analysis/newAndOld_analysis";

export default {
  components: {
    generate,
  },

  data() {
    return {
      newMemberRateTotal: "", // 合计新会员占比
      loading: false,
      control: false,
      form: {
        // 表单查询条件
        orderTimeStart: "",
        orderTimeEnd: "",
        openCardTimeStart: "",
        openCardTimeEnd: "",
        statisticsType: 1,
      },
      bindRadio: 7,
      orderRadio: 7,
      radioList: [
        // 下单时间
        {
          label: "近7天",
          value: 7,
        },
        {
          label: "近15天",
          value: 15,
        },
        {
          label: "近30天",
          value: 30,
        },
        {
          label: "近90天",
          value: 90,
        },
        {
          label: "近180天",
          value: 180,
        },
      ],
      dimensionList: [
        // 客户类型
        {
          label: "自然日",
          value: 1,
        },
        {
          label: "自然月",
          value: 2,
        },
        {
          label: "自然年",
          value: 3,
        },
      ],
      tableData: [], // 表格数据
      exportParams: {}, // 导出参数
    };
  },
  created() {
    // 埋点
    this.buriedPoint(1, "新老客分析", "数据分析", "客户分析");
    this.dateInit()
    this.queryData()
  },

  methods: {
    // 自定义合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (column.property == "memberRateVal") {
            sums[index] = this.newMemberRateTotal;
          }
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },

    orderRadioChange(val) {
      this.form.orderTimeStart = this.getDay(-val, "-");
      this.form.orderTimeEnd = this.getDay(0, "-");
    },

    bindRadioChange(val) {
      this.form.openCardTimeStart = this.getDay(-val, "-");
      this.form.openCardTimeEnd = this.getDay(0, "-");
    },

    // 时间初始化
    dateInit() {
      this.form.openCardTimeStart = this.getDay(-7, "-");
      this.form.openCardTimeEnd = this.getDay(0, "-");
      this.form.orderTimeStart = this.getDay(-7, "-");
      this.form.orderTimeEnd = this.getDay(0, "-");
    },

    clearBindTime() {
      this.form.openCardTimeStart = "";
      this.form.openCardTimeEnd = "";
    },

    clearOrderTime() {
      this.form.orderTimeStart = "";
      this.form.orderTimeEnd = "";
    },

    // 查询
    queryData() {
      if (!this.form.orderTimeStart) {
        return this.$message.error("请选择下单开始时间")
      }
      if (!this.form.orderTimeEnd) {
        return this.$message.error("请选择下单结束时间")
      }
      if (!this.form.openCardTimeStart) {
        return this.$message.error("请选择绑卡开始时间")
      }
      if (!this.form.openCardTimeEnd) {
        return this.$message.error("请选择绑卡结束时间")
      }
      this.exportParams = {...this.form}
      this.loading = true
      getTableData(this.form).then((res) => {
        this.loading = false
        if (res.code != 1) {
          return this.$message.error(res.message || res.data.message)
        }
        if (res.data && res.data.length > 1) {
          this.newMemberRateTotal = res.data[res.data.length - 1].newMemberRate
          res.data.pop()
        }
        this.tableData = res.data || []
      })
    },

    // 重置
    resetData() {
      this.orderRadio = 7
      this.bindRadio = 7
      this.form = {
        orderTimeStart: "",
        orderTimeEnd: "",
        openCardTimeStart: "",
        openCardTimeEnd: "",
        statisticsType: 1,
      }
      this.dateInit()
      this.queryData()
    },

    exportData() {
      this.control = true;
    },

    getphone(val) {
      const params = {
        ...this.exportParams,
        exportRemark: val,
      };
      exportDataOne(params).then((res) => {
        if (res.code == 1) {
          this.control = true;
        } else {
          this.$message.error(res.message || res.data.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.section-right-content-box {
  min-width: 1046px;
  margin-top: 10px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;

  .newAndOld_analysis {
    padding: 28px;

    .time_box {
      margin-right: 20px;
    }

    .status_btn {
      width: 98px;
      background-color: #fff;
      font-size: 14px;
      margin-left: 20px;
    }

    .status_btn1 {
      color: #fe4d45;
      border-color: #fe4d45;
      margin-left: 0;
    }

    .status_btn1:hover {
      color: #ffffff;
      background-color: #fe4d45;
    }

    .status_btn2 {
      margin-left: 8px;
      color: #333;
      border-color: #d9d9d9;
    }

    .status_btn2:hover {
      color: #fe4d45;
      border-color: #fe4d45;
      background-color: #ffe5e5;
    }

    .exportData {
      float: right;
    }

    .empty {
      padding: 40px 0;
      text-align: center;
      line-height: 30px;
    }

    .toolTipSet {
      width: 600px !important;
    }

    /deep/.el-table {
      overflow-x: auto;
    }
    /deep/.el-table__header-wrapper,
    .el-table__body-wrapper {
      overflow: visible;
    }
    /deep/.el-table__footer-wrapper {
      overflow: visible;
    }
    /deep/.el-table::after {
      position: relative;
    }
    /deep/.el-table--scrollable-x .el-table__body-wrapper {
      overflow: visible;
    }
  }
}
</style>
